'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _frontendUtils = require('@import/frontend-utils');
var _BaseApi2 = require('../BaseApi');
var _BaseApi3 = _interopRequireDefault(_BaseApi2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ListProducerApi = function (_BaseApi) {
  (0, _inherits3.default)(ListProducerApi, _BaseApi);
  function ListProducerApi() {
    (0, _classCallCheck3.default)(this, ListProducerApi);
    return (0, _possibleConstructorReturn3.default)(this, (ListProducerApi.__proto__ || Object.getPrototypeOf(ListProducerApi)).call(this, _frontendUtils.endpoints.listProducerBaseUrl));
  }
  (0, _createClass3.default)(ListProducerApi, [{
    key: 'generate',
    value: function generate(url, resourceId) {
      return this.makeRequest({
        method: 'POST',
        url: '',
        body: {
          url: url,
          resourceId: resourceId
        }
      });
    }
  }]);
  return ListProducerApi;
}(_BaseApi3.default);
exports.default = ListProducerApi;